
import React from 'react';

const Hero: React.FC = () => {
  const heroImageUrl = "https://drive.google.com/thumbnail?id=1anuUN5RnuWZEX2U20Ze4iPAG8wc2ZhYt&sz=w1200";

  return (
    <section className="relative overflow-hidden pt-12 pb-20 lg:pt-24 lg:pb-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[55%_45%] gap-12 items-center">
          <div className="flex flex-col gap-6 lg:gap-8">
            <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full w-fit">
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-wider">Licensed & Insured Florida Contractor</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight text-dark-gray dark:text-white tracking-tight">
              Protect Your Home with <span className="text-primary block sm:inline-block md:block lg:inline-block">Margate Roofing</span>
            </h1>
            
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 dark:text-gray-400 max-w-xl leading-relaxed">
              Trusted local specialists for South Florida's unique climate. We deliver premium tile, shingle, and metal roofing solutions designed to withstand storm season.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <button className="bg-accent text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg hover:scale-105 transition-transform shadow-xl shadow-accent/25">
                Free Roof Inspection
              </button>
              <a href="tel:5551234567" className="bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all text-dark-gray dark:text-white flex items-center justify-center">
                Click Here to Call
              </a>
            </div>
            
            <div className="flex items-center gap-4 sm:gap-6 pt-4 text-gray-400">
              <div className="flex flex-col items-center gap-1">
                <span className="text-lg sm:text-xl font-black text-primary leading-none">A+</span>
                <span className="text-[8px] sm:text-[10px] font-bold text-center uppercase tracking-tighter">BBB Rating</span>
              </div>
              <div className="h-8 w-px bg-gray-200 dark:bg-gray-800"></div>
              <div className="flex flex-col items-center gap-1">
                <span className="text-lg sm:text-xl font-black text-primary leading-none">GAF</span>
                <span className="text-[8px] sm:text-[10px] font-bold text-center uppercase tracking-tighter">Certified</span>
              </div>
              <div className="h-8 w-px bg-gray-200 dark:bg-gray-800"></div>
              <div className="flex flex-col items-center gap-1">
                <span className="text-lg sm:text-xl font-black text-primary leading-none">25+</span>
                <span className="text-[8px] sm:text-[10px] font-bold text-center uppercase tracking-tighter">Years Exp</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute -inset-4 bg-primary/10 rounded-[2rem] blur-3xl -z-10 animate-pulse"></div>
            <div className="w-full h-[400px] sm:h-[500px] lg:h-[600px] rounded-2xl bg-gray-100 dark:bg-gray-800 border-4 border-white dark:border-gray-800 shadow-2xl relative overflow-hidden">
              <img 
                src={heroImageUrl} 
                alt="Professional Roofing Project" 
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = "https://images.unsplash.com/photo-1635424710928-0544e8512efe?auto=format&fit=crop&q=80&w=1200";
                }}
              />
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 dark:bg-dark-gray/95 p-5 rounded-xl backdrop-blur-sm shadow-xl border border-gray-100 dark:border-gray-700">
                <div className="flex items-center gap-4">
                  <div className="bg-green-500 rounded-full w-6 h-6 flex items-center justify-center shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                      <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-black text-dark-gray dark:text-white">Recent Project Completed</p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">Margate, Florida • 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
